import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/deviceRole/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/deviceRole/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/deviceRole/updateById', data)
}

// 根据ID修改默认门禁组状态
export function updateStatusById (data) {
  return request.post('/business/deviceRole/updateStatusById', data)
}

// 【海康】全量同步访客权限组接口
export function syncPrivilege (data) {
  return request.post('/business/hksync/syncPrivilege', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/deviceRole/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/deviceRole/delete/batch', {
    params: {
      ids
    }
  })
}
